import { createSlice } from '@reduxjs/toolkit'
import PerimetersThunk from '../action/PerimetersThunk'
import PerimeterDto from 'perimeters/dto/PerimeterDto'
import { createIndex } from '../../utils/StoreUtils'
import CompanyOwnerDto from '../dto/CompanyOwnerDto'
import PrivateOwnerDto from '../dto/PrivateOwnerDto'
import PerimetersFolderDto from 'perimeters/dto/PerimetersFolderDto'
import OwnerGroupDto from 'perimeters/dto/OwnerGroupDto'

export const initialState = {
    perimetersFolder: [],
    perimeters: [],
    mortgages: [],
    perimeterFolderLastEvent: {},
    perimetersFolderPrivateOwners: [],
    perimetersFolderPrivateOwnersIndex: [],
    perimetersFolderCompanyOwners: [],
    perimetersFolderCompanyOwnersIndex: [],
    folderParcels: [],
    ownersAccounts: [],
}

const store = createSlice({
    name: 'perimeters',
    initialState,
    reducers: {
        receiveOwnersAccounts: (state, action) => {
            state.ownersAccounts = action.payload.map(p => new OwnerGroupDto(p))
        },
        addOwnersAccounts: (state, action) => {
            state.ownersAccounts = [...state.ownersAccounts.filter(og => og.communalAccount !== action.payload[0]?.communalAccount), ...action.payload]
        },
        receiveFolderParcels: (state, action) => {
            state.folderParcels = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(PerimetersThunk.getPerimetersFolders.pending, (state) => {
            state.perimetersFolder = []
        })
        builder.addCase(PerimetersThunk.getPerimetersFolders.fulfilled, (state, action) => {
            state.perimetersFolder = action.payload.map(pf => new PerimetersFolderDto(pf))
        })
        builder.addCase(PerimetersThunk.getPerimeters.pending, (state) => {
            state.perimeters = []
        })
        builder.addCase(PerimetersThunk.getPerimeters.fulfilled, (state, action) => {
            state.perimeters = action.payload.map(p => new PerimeterDto(p))
        })
        builder.addCase(PerimetersThunk.getMortgages.pending, (state) => {
            state.mortgages = []
        })
        builder.addCase(PerimetersThunk.getMortgages.fulfilled, (state, action) => {
            state.mortgages = action.payload
        })
        builder.addCase(PerimetersThunk.getPerimeterFolderLastEvent.fulfilled, (state, action) => {
            state.perimeterFolderLastEvent = action.payload
        })
        builder.addCase(PerimetersThunk.getPerimetersFolderPrivateOwners.pending, (state) => {
            state.perimetersFolderPrivateOwners = []
        })
        builder.addCase(PerimetersThunk.getPerimetersFolderPrivateOwners.fulfilled, (state, action) => {
            const privateOwners = action.payload.map(po => new PrivateOwnerDto(po))
            state.perimetersFolderPrivateOwners = action.payload
            state.perimetersFolderPrivateOwnersIndex = createIndex(privateOwners)
        })
        builder.addCase(PerimetersThunk.getPerimetersFolderCompanyOwners.pending, (state) => {
            state.companyOwners = []
        })
        builder.addCase(PerimetersThunk.getPerimetersFolderCompanyOwners.fulfilled, (state, action) => {
            const companyOwners = action.payload.map(co => new CompanyOwnerDto(co))
            state.perimetersFolderCompanyOwners = action.payload
            state.perimetersFolderCompanyOwnersIndex = createIndex(companyOwners)
        })
    },
})

export const PerimeterActionConstant = store.actions
export default store.reducer